import React, { useEffect, useRef } from "react";
import { Button, ButtonProps } from "@xometry/xometry_loft";
import { track } from "../../utils/analytics";
import { navigateToUrl } from "../../utils/contentUtils";

type CTAProps = {
  onClickFunction?: () => void;
  pageSection: string;
  ctaText: string;
  action?: string | null;
  linkURL?: string | null;
  target?: string | null;
  driftBotInteractionID?: number | null;
  additionalEventProps?: {};
} & ButtonProps;

const CTA = (props: CTAProps) => {
  const eventName = "CTA Clicked";
  const {
    pageSection,
    ctaText,
    action,
    linkURL,
    target,
    driftBotInteractionID,
    additionalEventProps,
    onClickFunction,
    disabled,
    children,
  } = props;

  const submitButton = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (submitButton?.current && disabled != undefined) {
      submitButton.current.disabled = disabled;
    }
  }, [submitButton]);

  return (
    <Button
      ref={submitButton}
      kind={props.kind}
      scale={props.scale}
      id={props.id}
      type={props.type}
      className={props.className}
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        track(eventName, {
          page_section: pageSection,
          cta_text: ctaText,
          action: action,
          link_URL: linkURL,
          drift_bot_interaction_id: driftBotInteractionID,
          ...additionalEventProps,
        });
        e.stopPropagation();
        switch (action) {
          case "Launch Drift Bot":
            if (driftBotInteractionID)
              window.drift.api.startInteraction({
                interactionId: driftBotInteractionID,
              });
            break;
          case "Open URL":
            navigateToUrl(linkURL, target);
            break;
          default:
            navigateToUrl(linkURL, target);
        }
        if (onClickFunction) onClickFunction();
      }}
    >
      {/* Children is before cta text to allow for icons to prepend text */}
      {children}
      {props.ctaText}
    </Button>
  );
};

export default CTA;
